import { HttpErrorResponse } from '@angular/common/http';
import { trimStringFields } from 'src/app/utils/string-utils'
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { forkJoin, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { MyDocsModel } from 'src/app/models/upload/mydocs.model';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { GlobalService } from 'src/app/service/global.service';
import { LoggerService } from 'src/app/service/logger.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { ManageCodesService } from 'src/app/service/managecodes.service';
import { MyDocsService } from 'src/app/service/mydocs.service';
import { NotificationService } from 'src/app/service/notification.service';
import { UserManagementService } from 'src/app/service/user-management.service';

@Component({
  selector: 'app-new-users',
  templateUrl: './new-users.component.html',
  styleUrls: ['./new-users.component.css']
})
export class NewUsersComponent implements OnInit {

  userModel = new AddUser();
  users: AddUser[] = [];
  userData: AddUser[] = [];
  supervisorData: AddUser[] = [];
  newUsers: AddUser[] = [];
  salesChnlsUserData: AddUser[] = [];
  selectedSalesChnl: AddUser[] = [];
  userTypes: string[] = [];
  comPlansUserData: AddUser[] = [];
  allComPlansUserData: AddUser[] = [];
  salesRepTypesList: AddUser[] = [];
  salesRepTypes: string[] = [];
  corps: number[] = [];
  payrollCalendarData: AddUser[] = [];
  hidefields: boolean = true;
  value: string | undefined;
  otherFields: boolean = true;
  repUserType: boolean = true;
  managerUserType: boolean = false;
  otherUserType: boolean = false;
  salesChannelAdmin: boolean = false;
  isSalesRepIdInvalid: boolean = false;
  selectedCommissionPlans: number[] = [];
  header: string = 'Create New Users';
  changeColor: boolean[] = [];
  rowcolor: string = 'tablerow';
  sub: any;
  page: string = '';
  returnTo: string = '';
  supervisorNamesSet = new Set<string>();
  ascCorps: any = [];
  userDocData: MyDocsModel[];
  docName: string = '';
  roles: UserManagementModel[];
  payrollCalender: string[];
  effDate: Date;
  @Input() placeholder: string = 'Select Employee';
  filteredCommPlans: Observable<AddUser[]> | undefined;
  selectControl = new FormControl();
  selectedCommplans: AddUser[] = [];
  selectedCommplanIds: string = '';
  empid: string = '';
  org_effective_date: Date = null;

  filteredSalesChannelValues: Observable<AddUser[]> | undefined;
  controlSc = new FormControl();
  filteredSalesRepTypeValues: Observable<string[]> | undefined;
  controlSrt = new FormControl();
  filteredSupValues: Observable<AddUser[]> | undefined;
  controlSup = new FormControl();
  private readonly supervisorDisplayLimit = 50;
  private supervisorSearchCache = new Map<string, AddUser[]>();
  pending: boolean;
  roleNames: string[] = [];
  addNew: boolean = false;
  isAccessDisabled: boolean = false;
  isChecked: boolean = false;
  checkboxChecked: string = "";

  salesChannels: string[] = [];

  @ViewChild('myForm') myForm: NgForm;
  @ViewChild('fnameInput') fnameInput: ElementRef;
  @ViewChild('lnameInput') lnameInput: ElementRef;
  @ViewChild('userRoleInput') userRoleInput: ElementRef;
  @ViewChild('userTypeInput') userTypeInput: ElementRef;
  @ViewChild('peoplesoftIdInput') peoplesoftIdInput: ElementRef;
  @ViewChild('compasEmpIdInput') compasEmpIdInput: ElementRef;
  @ViewChild('networkidInput') networkidInput: ElementRef;
  @ViewChild('salesrepidInput') salesrepidInput: ElementRef;
  @ViewChild('emailaddressInput') emailaddressInput: ElementRef;
  @ViewChild('effectivedateInput') effectivedateInput: ElementRef;
  @ViewChild('calendartypeInput') calendartypeInput: ElementRef;
  @ViewChild('supervisornameInput') supervisornameInput: ElementRef;
  @ViewChild('salesrepchanneldescInput') salesrepchanneldescInput: ElementRef;
  @ViewChild('commplanidInput') commplanidInput: ElementRef;
  @ViewChild('commissionableInput') commissionableInput: ElementRef;

  constructor(private fb: FormBuilder, private manageCodesService: ManageCodesService, private router: Router,
    private route: ActivatedRoute,
    private logger: LoggerService,
    private manageUserService: ManageUserService,
    private myDocsService: MyDocsService,
    private notificationService: NotificationService, private authGaurdService: AuthGaurdService,
    private usermanagementService: UserManagementService, private globalService: GlobalService) {
  }

  ngOnInit(): void {
    this.filterSupervisors();
    this.loadPageData();

    this.route.queryParams.subscribe(params => {
      this.page = params['page'];
      this.returnTo = params['returnTo'] || '';

      if (this.page === 'pending-users') {
        this.pending = true;
      } else if (this.page === 'newUser') {
        this.pending = true;
        this.addNew = true;

        if (this.manageUserService.userModel?.employeeId) {
          this.userModel.employeeId = this.manageUserService.userModel.employeeId;
        }
        if (this.manageUserService.userModel?.id) {
          this.userModel.id = this.manageUserService.userModel.id;
        }
        if (this.manageUserService.userModel?.first_name) {
          this.userModel.first_name = this.manageUserService.userModel.first_name;
        }
        if (this.manageUserService.userModel?.last_name) {
          this.userModel.last_name = this.manageUserService.userModel.last_name;
        }
      } else if (this.page === 'updatePersonnelUser') {
        this.pending = false;
      } else {
        this.addNew = true;
      }

    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
    this.isAccessDisabled = this.globalService._permissionCheck('manage-users');
    if (this.isAccessDisabled) {
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
    }

    this.selectedCommplans = [];
    this.filterCommPlans();
  }

  private hasCachedPrePopulatedData(): boolean {
    return (this.manageUserService.salesChnlsUserData?.length ?? 0) > 0
      && (this.manageUserService.userTypes?.length ?? 0) > 0
      && (this.manageUserService.allComPlansUserData?.length ?? 0) > 0;
  }

  private loadPageData(): void {
    const useCachedFields = this.hasCachedPrePopulatedData();
    const baseRequests = {
      payroll: this.manageUserService.getPayrollCalendar(),
      roles: this.usermanagementService.getRoles(),
      corps: this.manageCodesService.getCorps(),
    };

    if (useCachedFields) {
      forkJoin(baseRequests).subscribe({
        next: (result) => this.applyPageLoadResult(result, null),
        error: (errorResponse: HttpErrorResponse) => {
          const msg: any = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      });
      return;
    }

    forkJoin({
      ...baseRequests,
      fields: this.manageUserService.getPrePopulatedUserData(),
    }).subscribe({
      next: (result) => this.applyPageLoadResult(result, result.fields),
      error: (errorResponse: HttpErrorResponse) => {
        const msg: any = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    });
  }

  private applyPageLoadResult(
    result: { payroll: any; roles: UserManagementModel[]; corps: { corp: number }[] },
    fields: AddUser[] | null
  ): void {
    this.payrollCalendarData = result.payroll;
    this.roleNames = result.roles
      .map(role => role.role_name)
      .sort((a, b) => a.localeCompare(b));

    this.corps = result.corps.map(corpdata => corpdata.corp);

    if (fields === null) {
      this.hydrateDropdownsFromServiceCache();
    } else {
      this.userData = fields;
      this.parsePrePopulatedUserData(this.userData);
      this.syncDropdownsToService();
    }

    this.filterSalesChannels();
    this.filterSalesRepTypes();
    this.selectedCorps();
  }

  getPayrollCalendar() {
    this.loadPageData();
  }

  getPrePopulatedUserData() {
    this.loadPageData();
  }

  private hydrateDropdownsFromServiceCache(): void {
    this.salesChnlsUserData = this.manageUserService.salesChnlsUserData;
    this.userTypes = this.manageUserService.userTypes;
    this.allComPlansUserData = this.manageUserService.allComPlansUserData;
    this.comPlansUserData = this.manageUserService.comPlansUserData;
    this.salesRepTypes = this.manageUserService.salesRepTypes;
    this.payrollCalender = this.manageUserService.payrollCalender;
    this.filterCommissionPlansBySalesChannel();
  }

  private parsePrePopulatedUserData(data: AddUser[]): void {
    this.payrollCalender = [];
    this.salesChnlsUserData = [];
    this.salesRepTypes = [];
    this.userTypes = [];
    this.allComPlansUserData = [];
    this.comPlansUserData = [];
    this.salesChannels = [];

    for (const userInfo of data) {
      if (userInfo.commission_plan != null) {
        this.allComPlansUserData.push(userInfo);
      } else if (userInfo.sales_rep_channel != null && userInfo.sales_rep_channel_desc != null) {
        this.salesChnlsUserData.push(userInfo);
        this.salesChannels.push(userInfo.sales_rep_channel);
      } else if (userInfo.user_type != null) {
        this.userTypes.push(userInfo.user_type);
      } else if (userInfo.sales_rep_type != null) {
        this.salesRepTypes.push(userInfo.sales_rep_type);
      } else if (userInfo.calendar_type != null) {
        this.payrollCalender.push(userInfo.calendar_type);
      }
    }

    if (this.salesChannels.length > 1) {
      this.salesChannels.sort((a, b) => a.localeCompare(b));
    }
    if (this.userTypes.length > 1) {
      this.userTypes.sort((a, b) => a.localeCompare(b));
    }
    if (this.salesRepTypes.length > 1) {
      this.salesRepTypes.sort((a, b) => a.localeCompare(b));
    }
    if (this.payrollCalender.length > 1) {
      this.payrollCalender.sort((a, b) => a.localeCompare(b));
    }
    if (this.allComPlansUserData.length > 1) {
      this.allComPlansUserData.sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);
    }
    this.filterCommissionPlansBySalesChannel();
  }

  private syncDropdownsToService(): void {
    this.manageUserService.salesChnlsUserData = this.salesChnlsUserData;
    this.manageUserService.userTypes = this.userTypes;
    this.manageUserService.allComPlansUserData = this.allComPlansUserData;
    this.manageUserService.comPlansUserData = this.comPlansUserData;
    this.manageUserService.salesRepTypes = this.salesRepTypes;
    this.manageUserService.payrollCalender = this.payrollCalender;
  }

  onSalesChannelChange(): void {
    const selectedChannel = this.salesChnlsUserData.find(
      channel => channel.sales_rep_channel === this.userModel.sales_rep_channel
    );
    if (selectedChannel) {
      this.userModel.sales_rep_channel_desc = selectedChannel.sales_rep_channel_desc;
    }
    this.filterCommissionPlansBySalesChannel();
  }

  private filterCommissionPlansBySalesChannel(): void {
    const source = this.allComPlansUserData;

    if (!this.userModel.sales_rep_channel) {
      this.comPlansUserData = source.slice()
        .sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);
      return;
    }

    const selectedChannel = this.salesChnlsUserData.find(
      channel => channel.sales_rep_channel === this.userModel.sales_rep_channel
    );
    const channelDesc = selectedChannel?.sales_rep_channel_desc ?? this.userModel.sales_rep_channel_desc;

    this.comPlansUserData = source
      .filter(plan => this.planMatchesSalesChannel(plan, this.userModel.sales_rep_channel, channelDesc))
      .sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);

    if (this.userModel.comm_plan_id != null &&
      !this.comPlansUserData.some(plan => Number(plan.comm_plan_id) === Number(this.userModel.comm_plan_id))) {
      this.userModel.comm_plan_id = null;
    }
    if (this.selectedCommissionPlans?.length) {
      this.selectedCommissionPlans = this.selectedCommissionPlans.filter(planId =>
        this.comPlansUserData.some(plan => Number(plan.comm_plan_id) === Number(planId))
      );
    }
  }

  private requiresExactChannelMatch(channelCode: string, channelDesc: string): boolean {
    const combined = `${channelCode || ''} ${channelDesc || ''}`.toLowerCase();
    return combined.includes('direct sales') && combined.includes('bpo');
  }

  private channelValuesMatchExactly(left: string, right: string): boolean {
    return !!left && !!right && left === right;
  }

  private planMatchesSalesChannel(plan: AddUser, channelCode: string, channelDesc: string): boolean {
    const planChannel = this._normalizeValue(plan.sales_rep_channel || '');
    const planDesc = this._normalizeValue(plan.sales_channel_desc || '');
    const channelToken = this._normalizeValue(channelCode || '');
    const descToken = this._normalizeValue(channelDesc || '');

    if (this.requiresExactChannelMatch(channelCode, channelDesc)) {
      return this.channelValuesMatchExactly(planChannel, channelToken)
        || this.channelValuesMatchExactly(planDesc, descToken)
        || this.channelValuesMatchExactly(planChannel, descToken)
        || this.channelValuesMatchExactly(planDesc, channelToken);
    }

    const planValues = [planChannel, planDesc].filter(value => value.length > 0);
    const matchTokens = [channelToken, descToken].filter(value => value.length > 0);

    for (const token of matchTokens) {
      for (const planValue of planValues) {
        if (planValue === token) {
          return true;
        }
        if (planValue.startsWith(token) || token.startsWith(planValue)) {
          return true;
        }
      }
    }
    return false;
  }


  filter() {
    this.hidefields = false;
  }

  // getSupervisors() {
  //   this.manageCodesService.getSupervisors()
  //     .subscribe((data: any) => {
  //       //this.logger.info(data);
  //       this.supervisorData = data;
  //       this.filterSupervisors();
  //       //console.log(" this.supervisorData = " + JSON.stringify(this.supervisorData));
  //     }, (errorResponse: HttpErrorResponse) => {
  //       var msg: any;
  //       msg = errorResponse;
  //       this.notificationService.sendNotification(NotificationType.ERROR, msg);
  //     });
  // }


  filterSupervisors() {
    this.filteredSupValues = this.controlSup.valueChanges.pipe(
      startWith(''),
      distinctUntilChanged(),
      switchMap(value => {
        const searchValue = (value ?? '').trim();
        if (searchValue.length < 3) {
          return of(this._filterSup(searchValue));
        }

        const cached = this.supervisorSearchCache.get(searchValue);
        if (cached) {
          this.supervisorData = cached;
          return of(this._filterSup(searchValue));
        }

        return this.manageCodesService.getEmpSupervisors(searchValue).pipe(
          map((data: AddUser[]) => {
            this.supervisorData = data ?? [];
            this.supervisorSearchCache.set(searchValue, this.supervisorData);
            return this._filterSup(searchValue);
          }),
          catchError((errorResponse: HttpErrorResponse) => {
            const msg: any = errorResponse;
            this.notificationService.sendNotification(NotificationType.ERROR, msg);
            return of([]);
          })
        );
      })
    );
  }

  private _filterSup(value: string | null): AddUser[] {
    const filterValue = this._normalizeValue(value || '');
    return this.supervisorData
      .filter(item => this._normalizeValue(item.supervisor_name).includes(filterValue))
      .slice(0, this.supervisorDisplayLimit);
  }

  filterSalesChannels() {
    this.filteredSalesChannelValues = this.controlSc.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSC(value))
    );
  }
  private _filterSC(value: string): AddUser[] {
    const filterValue = this._normalizeValue(value);
    return this.salesChnlsUserData.filter(item => this._normalizeValue(item.sales_rep_channel_desc).includes(filterValue));
  }

  filterSalesRepTypes() {
    this.filteredSalesRepTypeValues = this.controlSrt.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSrt(value))
    );
  }
  private _filterSrt(value: string): string[] {
    const filterValue = this._normalizeValue(value);
    return this.salesRepTypes.filter(item => this._normalizeValue(item).includes(filterValue));
  }
  private _normalizeValue(value: string | null | undefined): string {
    return (value ?? '').toString().toLowerCase().replace(/\s/g, '');
  }



  getPrePopulatedUserData1() {
    this.salesChnlsUserData = this.manageUserService.salesChnlsUserData;
    this.userTypes = this.manageUserService.userTypes;
    this.comPlansUserData = this.manageUserService.comPlansUserData.sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);

    this.salesRepTypes = this.manageUserService.salesRepTypes;
    this.payrollCalender = this.manageUserService.payrollCalender;
    this.selectedCommplans = [];
    this.newUsers = []
    //this.getSupervisors();
    this.getCorps();
    this.effDate = this.manageUserService.selectedUserModel.effective_date;


    if (this.page === 'newUser') {
      this.userModel = new AddUser();
    } else {
      this.userModel = this.manageUserService.selectedUserModel;
      //console.log(this.userModel);
    }


    this.org_effective_date = this.userModel.effective_date;
    //console.log(this.org_effective_date);
    if (this.manageUserService.selectedUserModel.commissionable)
      this.userModel.commissionable = this.manageUserService.selectedUserModel.commissionable;
    else
      this.userModel.commissionable = 'Y';
    this.salesChnlsUserData.forEach(scUser => {
      if (scUser.sales_rep_channel === this.userModel.sales_rep_channel) {
        this.userModel.sales_rep_channel_desc = scUser.sales_rep_channel_desc;
      }
    });
    this.getComDoc();
    this.getRoles();
    this.userModel.corps = [];
    this.corps = [];
    this.supervisorNamesSet = this.manageUserService.supervisorNamesSet;
    this.manageUserService.getPrePopulatedUserData()
      .subscribe((data: AddUser[]) => {
        this.logger.info(data);
        this.userData = data;
        // console.log(this.userData);
        this.filterSalesChannels();
        this.filterSalesRepTypes();
        this.empid = this.userData[0].employeeId;

        if (this.empid === "" || this.empid === null) {
          this.empid = this.userModel.employeeId;
        }
        //console.log(this.empid);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
    this.selectedUserType(this.userModel.userRole);
    this.getAsscCommPlanIds(this.userModel.employeeId);

  }

  private getAsscCommPlanIds(empId: string) {
    //console.log(empId);
    this.manageUserService.filterByEmpId(empId)
      .subscribe((userDataList: AddUser[]) => {
        if (userDataList.length > 0) {
          for (let user of userDataList) {
            this.comPlansUserData.forEach((value: any, index: any) => {
              //if (value.comm_plan_id == user.comm_plan_id) this.comPlansUserData.splice(index, 1);
            });
          }
        }
        // console.log(this.userModel.commission_plan);

      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }



  selectedUserType(event: any) {
    //console.log(event.target.value);
    if (event?.target)
      this.value = event.target.value;
    else
      this.value = event;
    if (this.value === 'salesRep' || this.value === 'Sales Representative' || this.value === 'Sales Operations' || this.value === 'No Access') {
      this.hidefields = true;
      this.otherFields = true;
      this.repUserType = true;
      this.managerUserType = false;
      this.otherUserType = false;
      this.salesChannelAdmin = false;
      this.header = 'Create Sales Representative'
    } else if (this.value === 'SUPERVISOR_MANAGER' || this.value === 'Supervisor') {
      this.hidefields = false;
      this.otherFields = true;
      this.managerUserType = true;
      this.otherUserType = false;
      this.repUserType = false;
      this.salesChannelAdmin = false;
      this.header = 'Create Supervisor/Manager'
    } else if (this.value === 'Sales Channel Admin') {
      this.hidefields = true;
      this.otherFields = false;
      this.otherUserType = true;
      this.managerUserType = false;
      this.repUserType = false;
      this.salesChannelAdmin = true;
      this.header = 'Create Sales Channel Admin'
    } else {
      this.hidefields = true;
      this.otherFields = false;
      this.otherUserType = true;
      this.managerUserType = false;
      this.repUserType = false;
      this.salesChannelAdmin = false;
      this.header = 'Create Admin'
    }
  }

  public getComDoc() {
    this.myDocsService.filterUserDocByEmp(this.userModel.employeeId).subscribe(
      (response: MyDocsModel[]) => {
        this.userDocData = response;
        this.docName = this.userDocData.map(userDoc => userDoc.doc_name).join(' ,');
        if (this.userDocData.length > 0) {
          this.docName += ' ,';
        }
        this.userModel.userDoc = this.docName;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }

    )
  }

  public getRoles() {
    this.usermanagementService.getRoles().subscribe(
      (response: UserManagementModel[]) => {
        this.roles = response;
        this.roleNames = response
          .map(role => role.role_name)
          .sort((a, b) => a.localeCompare(b));
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }




  getCorps() {
    this.manageCodesService.getCorps()
      .subscribe((data: any) => {
        this.corps = data.map((corpdata: { corp: number }) => corpdata.corp);
        this.selectedCorps();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  checkAll() {
    this.userModel.changeColor = [];
    this.userModel.corps = [];
    for (let corp of this.corps) {
      this.userModel.changeColor.push(true);
      this.userModel.corps.push(corp);
    }
  }

  uncheckAll() {
    this.userModel.changeColor = this.corps.map(() => false);
    this.userModel.corps = [];
  }

  selectedCorps() {
    this.userModel.changeColor = [];
    this.userModel.corps = [];
    const selectedCorpSet = new Set<number>();

    if (this.userModel.assc_corps) {
      this.ascCorps = this.userModel.assc_corps.split(',');
      this.ascCorps.forEach((value: any) => {
        const numeric = Number(value);
        if (!Number.isNaN(numeric)) {
          this.userModel.corps.push(numeric);
          selectedCorpSet.add(numeric);
        }
      });
    }

    for (const corp of this.corps) {
      this.userModel.changeColor.push(selectedCorpSet.has(corp));
    }
  }

  checkValue1(event: any) {
    this.isChecked = event;
    //console.log(this.isChecked);
  }

  checkValue(event: any) {
    this.isChecked = event.checked;
    console.log(this.isChecked);
    if (this.isChecked) {
      alert("New COMPAS ID is only needed if the employee needs to get paid for 2 commission plans in the same month.");
    }
  }

  // saveAfterValidate() {
  //   const orgEffDate = new Date(this.org_effective_date);
  //   const newEffDate = new Date(this.userModel.effective_date);
  //   console.log("orgEffDate = " + orgEffDate.getTime());
  //   console.log("newEffDate = " + newEffDate.getTime());

  //   console.log("this.isChecked = " + this.isChecked);

  //   if (this.isChecked === false) {
  //     console.log("Inside IF");
  //     this.checkboxChecked = "false";
  //   } else {
  //     console.log("Inside ELSE");
  //     this.checkboxChecked = "true";
  //   }

  //   console.log("checkboxChecked = " + this.checkboxChecked);

  //   this.saveNewUser();

  // }

  // saveUser() {
  //   console.log(this.myForm.valid);
  //   if (!this.myForm.valid) {
  //     // Focus on the first invalid field
  //     this.userRoleInput.nativeElement.focus();
  //     this.userTypeInput.nativeElement.focus();
  //     this.fnameInput.nativeElement.focus();
  //     this.lnameInput.nativeElement.focus();
  //     this.peoplesoftIdInput.nativeElement.focus();
  //     this.compasEmpIdInput.nativeElement.focus();
  //     this.networkidInput.nativeElement.focus();
  //     this.emailaddressInput.nativeElement.focus();

  //     if (this.userModel.userRole === "Supervisor") {
  //       this.effectivedateInput.nativeElement.focus();
  //       this.calendartypeInput.nativeElement.focus();
  //       this.supervisornameInput.nativeElement.focus();
  //       this.salesrepchanneldescInput.nativeElement.focus();
  //       this.commplanidInput.nativeElement.focus();
  //       this.commissionableInput.nativeElement.focus();
  //     } else {
  //       this.salesrepidInput.nativeElement.focus();
  //       this.effectivedateInput.nativeElement.focus();
  //       this.calendartypeInput.nativeElement.focus();
  //       this.supervisornameInput.nativeElement.focus();
  //       this.salesrepchanneldescInput.nativeElement.focus();
  //       this.commplanidInput.nativeElement.focus();
  //       this.commissionableInput.nativeElement.focus();
  //     }
  //   } else {
  //     this.saveNewUser();
  //     //this.saveAfterValidate();
  //   }
  // }

  /**
 * Prepare commission plan data based on role type
 * For Sales Channel Admin: Convert array to comma-separated string for complan_id
 * For other roles: Use single comm_plan_id
 */
  prepareCommissionPlanData(): void {
    if (this.salesChannelAdmin && this.selectedCommissionPlans.length > 0) {
      // Convert array of commission plan IDs to comma-separated string
      this.userModel.commplan_id = this.selectedCommissionPlans.join(',');
      this.userModel.comm_plan_id = this.selectedCommissionPlans[0];
      this.userModel.commPlanId = null;
      console.log('Sales Channel Admin - Multiple commission plans:', this.userModel.commplan_id);
    } else if (!this.salesChannelAdmin && this.userModel.comm_plan_id) {
      // For other roles, keep single commission plan in comm_plan_id
      console.log('Single commission plan:', this.userModel.comm_plan_id);
    }
  }



  private saveNewUser() {
    // Prepare commission plan data before validation and saving
    this.prepareCommissionPlanData();

    if (this.salesChannelAdmin && this.selectedCommissionPlans.length === 0) {
      this.sendNotification(NotificationType.ERROR, 'Please select at least one Commission Plan');
      return;
    }

    console.log(this.myForm.valid);
    if (!this.myForm.valid && !this.salesChannelAdmin) {
      // Focus on the first invalid field
      this.userRoleInput.nativeElement.focus();
      this.userTypeInput.nativeElement.focus();
      this.fnameInput.nativeElement.focus();
      this.lnameInput.nativeElement.focus();
      this.peoplesoftIdInput.nativeElement.focus();
      this.compasEmpIdInput.nativeElement.focus();
      this.networkidInput.nativeElement.focus();
      this.emailaddressInput.nativeElement.focus();

      if (this.userModel.userRole === "Supervisor") {
        this.effectivedateInput.nativeElement.focus();
        this.calendartypeInput.nativeElement.focus();
        this.supervisornameInput.nativeElement.focus();
        this.salesrepchanneldescInput.nativeElement.focus();
        this.commplanidInput.nativeElement.focus();
        this.commissionableInput.nativeElement.focus();
      } else {
        this.salesrepidInput.nativeElement.focus();
        this.effectivedateInput.nativeElement.focus();
        this.calendartypeInput.nativeElement.focus();
        this.supervisornameInput.nativeElement.focus();
        this.salesrepchanneldescInput.nativeElement.focus();
        this.commplanidInput.nativeElement.focus();
        this.commissionableInput.nativeElement.focus();
      }
    } else if (this.isSalesRepIdInvalid) {
      this.sendNotification(NotificationType.ERROR, 'The Sales Rep ID is assigned to an Active user, please use a different Sales Rep ID');
    } else if (this.shouldValidateSalesRepId()) {
      this.manageUserService.validateSalesRepId(
        this.userModel.sales_rep_id,
        '',
        this.userModel.effective_date
      ).subscribe(
        (isActive: boolean) => {
          if (isActive) {
            this.sendNotification(NotificationType.ERROR, 'The Sales Rep ID is assigned to an Active user, please use a different Sales Rep ID');
            return;
          }
          this.proceedWithSaveNewUser();
        },
        () => this.proceedWithSaveNewUser()
      );
    } else {
      this.proceedWithSaveNewUser();
    }
  }

  private shouldValidateSalesRepId(): boolean {
    return !!(
      this.userModel.sales_rep_id &&
      this.userModel.sales_rep_id.trim() !== '' &&
      this.userModel.sales_rep_id !== 'NA'
    );
  }

  onSalesRepIdBlur(): void {
    if (!this.shouldValidateSalesRepId()) {
      this.isSalesRepIdInvalid = false;
      return;
    }

    if (!this.userModel.effective_date) {
      this.sendNotification(NotificationType.ERROR, 'Please select Effective Date before validating Sales Rep ID');
      return;
    }

    this.manageUserService.validateSalesRepId(
      this.userModel.sales_rep_id,
      '',
      this.userModel.effective_date
    ).subscribe(
      (isActive: boolean) => {
        if (isActive) {
          this.sendNotification(NotificationType.ERROR, 'The Sales Rep ID is assigned to an Active user, please use a different Sales Rep ID');
          this.isSalesRepIdInvalid = true;
        } else {
          this.isSalesRepIdInvalid = false;
        }
      },
      (errorResponse: HttpErrorResponse) => {
        this.isSalesRepIdInvalid = false;
        const msg: any = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  private proceedWithSaveNewUser(): void {
    console.log("Inside saveNewUser");

    const orgEffDate = new Date(this.org_effective_date);
    const newEffDate = new Date(this.userModel.effective_date);
    console.log("orgEffDate = " + orgEffDate.getTime());
    console.log("newEffDate = " + newEffDate.getTime());

    console.log("this.isChecked = " + this.isChecked);

    if (this.isChecked === false) {
      console.log("Inside IF");
      this.checkboxChecked = "false";
    } else {
      console.log("Inside ELSE");
      this.checkboxChecked = "true";
    }

    console.log("checkboxChecked = " + this.checkboxChecked);

    const user = this.authGaurdService.loginUser()

    this.userModel.created_dt = new Date();
    this.userModel.created_by = user;
    this.userModel.profileStatus = 'complete';
    this.userModel.assc_corps = this.userModel.corps.toString();

    if (this.userModel.sales_rep_id === null || this.userModel.sales_rep_id === "") {
      this.userModel.sales_rep_id = "NA";
    }
    this.userModel = trimStringFields(this.userModel);

    if (this.userModel.userRole === "ADMIN" || this.userModel.userRole === "Sales Channel Admin") {
      this.submitNewUserAdmin(this.userModel);
    } else {
      if (this.userModel.userRole === "Sales Representative" || this.userModel.userRole === "No Access") {
        if (this.userModel.assc_corps === "" || this.userModel.assc_corps === "0" || this.userModel.assc_corps === null) {
          this.sendNotification(NotificationType.ERROR, `Please select at least one corp`);
        } else {
          this.submitNewUser(this.userModel);
        }
      } else {
        this.submitNewUser(this.userModel);
      }
    }
  }

  private submitNewUserAdmin(addUserModel: AddUser) {
    console.log("Inside submitNewUserAdmin");
    addUserModel.checkboxchecked = this.checkboxChecked;
    this.newUsers.push(addUserModel);
    // console.log(this.newUsers);
    this.manageUserService.saveUserAdmin(this.newUsers)
      .subscribe(response => {
        this.sendNotification(NotificationType.SUCCESS, `User Added Successfully`);
        location.reload();
      }, (errorResponse: HttpErrorResponse) => {
        console.log(errorResponse);
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
      )
  }

  private submitNewUser(addUserModel: AddUser) {
    console.log("Inside submitNewUser");
    const skipSupervisor =
      this.userModel.userRole === "ADMIN" || this.userModel.userRole === "Sales Channel Admin";

    if (addUserModel.supervisor_name == "" || addUserModel.supervisor_name == null || addUserModel.supervisor_name == undefined) {
      console.log("Inside IF");
      addUserModel.supervisor_id = 0;
    } else {
      console.log("Inside ELSE");
      let selectedOption = addUserModel.supervisor_name;
      var lastIndex = selectedOption.lastIndexOf("-");

      if (lastIndex >= 0) {
        addUserModel.supervisor_name = selectedOption.substring(0, lastIndex);
        addUserModel.supervisor_id = selectedOption.substring(lastIndex + 1);
      } else if (skipSupervisor) {
        addUserModel.supervisor_id = 0;
      }
    }

    // ADMIN and Sales Channel Admin do not require supervisor
    if (!skipSupervisor && (!addUserModel.supervisor_name || !addUserModel.supervisor_id)) {
      this.sendNotification(NotificationType.ERROR, `Please select supervisor in this format NAME-EMPLOYEEID`);
      return;
    }

    addUserModel.checkboxchecked = this.checkboxChecked;

    this.newUsers.push(addUserModel);

    // console.log(this.newUsers);
    this.manageUserService.saveUser(this.newUsers)
      .subscribe(response => {
        // response = response as ErrorResponseMessage;
        this.sendNotification(NotificationType.SUCCESS, `User Added Successfully`);

        // this.router.navigate(['/search-users']);
        // this.router.navigate(['/new-users']);
        location.reload();


      }, (errorResponse: HttpErrorResponse) => {
        console.log(errorResponse);
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
      )
  }

  private updateUsers() {
    console.log("Inside updateUsers");
    //console.log(this.userModel.corps);
    if (this.userModel.corps.length >= 1) {
      this.userModel.assc_corps = this.userModel.corps.toString();
      //console.log(this.userModel.assc_corps);
    } else {
      this.userModel.assc_corps = "";
      // console.log(this.userModel.assc_corps);
    }

    this.userModel.updated_dt = new Date();
    this.userModel.updated_by = this.authGaurdService.loginUser();
    // console.log(this.userModel.supervisor_name);

    if (this.userModel.supervisor_name == "" || this.userModel.supervisor_name == null || this.userModel.supervisor_name == undefined) {
      this.userModel.supervisor_id = 0;
    } else {
      let selectedOption = this.userModel.supervisor_name;//val.option.value;
      let supDetails = selectedOption.split("-");
      this.userModel.supervisor_name = supDetails[0];
      this.userModel.supervisor_id = supDetails[1];
    }

    const skipSupervisor =
      this.userModel.userRole === "ADMIN" || this.userModel.userRole === "Sales Channel Admin";

    if (!skipSupervisor && (!this.userModel.supervisor_name || !this.userModel.supervisor_id)) {
      this.sendNotification(NotificationType.ERROR, `Please select supervisor in this format NAME-EMPLOYEEID`);
      return;
    }

    // console.log(this.userModel.userRole);
    // console.log(this.userModel.assc_corps);
    if (this.userModel.userRole === "Sales Representative") {
      // console.log("Inside 1st IF");
      if (this.userModel.assc_corps === "" || this.userModel.assc_corps === "0" || this.userModel.assc_corps === null) {
        //console.log("Inside 2nd IF");
        this.sendNotification(NotificationType.ERROR, `Please select at least one corp`);
      } else {
        // console.log("Inside 1st ELSE");
        this.updateUser(this.userModel);
      }
    } else {
      //console.log("Inside 2nd ELSE");
      this.updateUser(this.userModel);
    }
  }

  private updateUser(addUserModel: AddUser) {
    // console.log(this.userModel);
    this.manageUserService.updateUser(addUserModel)
      .subscribe(response => {

        response = response as ErrorResponseMessage;
        this.sendNotification(NotificationType.SUCCESS, `User Updated Successfully`);

        this.getPrePopulatedUserData();
        if (this.page === 'pending-users') {
          this.router.navigate(['/pending-users']);
        } else {
          this.router.navigate(['/search-users']);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
      )
  }


  back() {
    if (this.returnTo === 'pending-users') {
      this.router.navigate(['/pending-users']);
      return;
    }

    if (this.page === 'pending-users' || this.page === 'newUser') {
      this.router.navigate(['/search-users'], { queryParams: { page: 'pending-users', returnTo: 'pending-users' } });
      return;
    }

    this.router.navigate(['/search-users']);
  }



  clickedRow(e: any) {
    //this.userModel.corps =[];
    var numeric = Number(e.target.innerText);
    // console.log("hhkhhh  ", numeric);
    //var exists = msgArr.some(o => o.objectId === data.objectId);
    if (!this.userModel.corps.includes(numeric)) {
      // console.log('value is not exist', e.target.innerText)
      this.userModel.corps.push(numeric);
    }
    else if (this.userModel.corps.includes(numeric)) {
      /// console.log('value is  exist', numeric)
      this.userModel.corps.forEach((element: number, index: any) => {
        if (element == e.target.innerText) this.userModel.corps.splice(index, 1);
      });
    }
    // console.log("clickedRow =  ", this.userModel.corps);
  }

  private sendNotification(notificationType: NotificationType, message: string): void {
    if (message) {
      this.notificationService.notify(notificationType, message);
    } else {
      this.notificationService.notify(notificationType, 'An error occurred. Please try again.');
    }
  }


  // START =====================================================================================================


  public displayFunction(distri: any) {
    // console.log("distri === " + JSON.stringify(distri));

    this.users = this.comPlansUserData.filter(distribute => distribute.comm_plan_id === distri.comm_plan_id);
    if (this.users.length > 0) {
      return this.users[0].commission_plan;
    }
    else
      return '';
    //  return this.comPlansUserData.filter(user => this._normalizeValue(user.commission_plan).includes(filterValue));
  }



  emitAdjustedData = (): void => {
    // const results: Array<string> = []
    var rest: string = "";
    // console.log("this.selectData===" + JSON.stringify(this.selectedCommplans));
    this.selectedCommplans.forEach((data: AddUser) => {
      rest = rest + data.comm_plan_id + ",";
      this.selectedCommplanIds = rest.slice(0, -1);
      this.userModel.commPlanId = this.selectedCommplanIds;
      // console.log("this.selectedCommplanIds===" + this.selectedCommplanIds);
      // results.push(data.empName);
    });
    // this.result.emit({ key: this.key, data: results });
    // console.log("this.result===" + JSON.stringify(this.result));
  };

  // removeChip = (data: AddUser): void => {
  //   this.toggleSelection(data);
  // };

  filterCommPlans() {
    this.filteredCommPlans = this.selectControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
    // console.log(' filteredApprovalValues', this.filteredCommPlans)
  }

  private _filter(value: string): AddUser[] {
    const filterValue = this._normalizeValue(value);
    //this.filteredValues = this.approvalValueSet.filter(street => this._normalizeValue(street.name).includes(filterValue));

    return this.comPlansUserData.filter(user => this._normalizeValue(user.commission_plan).includes(filterValue));
  }

  getSupId(val: any) {

    // let selectedOption = this.userModel.supName;//val.option.value;
    // let supDetails = selectedOption.split("-");
    // this.userModel.supervisor_name = supDetails[0];
    // this.userModel.supervisor_id = Number(supDetails[1]);
  }

  trackSupervisorOption(_index: number, sup: AddUser): string {
    return sup?.supervisor_name ?? _index.toString();
  }

  getSalesChnl1(userSC: AddUser, event: any) {
    if (event.source.selected) {
      this.userModel.sales_rep_channel = userSC.sales_rep_channel;
      this.onSalesChannelChange();
    }
  }

  getSalesChnl(event: any) {
    this.onSalesChannelChange();
  }
  // END =============================================================================================

  isLastDayOfMonth(date: Date | null): boolean {
    date = date ?? new Date();
    const dayOfMonth = date.getDate();
    const lastDayOfMonth = getLastDayOfMonth(date);

    return dayOfMonth === lastDayOfMonth;
  };

}

function getLastDayOfMonth(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), 1).getDate();
}
